export default __webpack_public_path__ + "static/media/1356.76149300.png";